import { DatePipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DropdownService } from "src/app/services/dropdown.service";

@Component({
  selector: "app-estudio-higienico",
  templateUrl: "./estudio-higienico.component.html",
  styleUrls: ["./estudio-higienico.component.scss"],
})
export class EstudioHigienicoComponent implements OnInit {
  fechaMuestreo: string = "";
  numeroPedido: string = "";
  proximoInforme: string = "";
  referenciaInforme: string = "";
  private readonly actuationCodeMap: Record<string, string> = {
    "E.H. Agentes Químicos (Elaboración)": "EHAgQuimico",
    "E.H. Biológica (Elaboración)": "EHBiologic",
    "E.H. Estrés térmico (Elaboración)": "EHETermico",
    "E.H. Iluminación (Elaboración)": "EHIluminacion",
    "E.H. Otros (Elaboración)": "EHOtros",
    "E.H. Ruido (Elaboración)": "EHRuido",
    "E.H. Vibraciones (Elaboración)": "EHVibraciones",
    "E.H. Campos electromagnéticos (Elaboración)": "EHElectromag",
    "E.H. Cargas electrostáticas (Elaboración)": "EHElectroestac",
    "E.H. Condiciones ambientales (Elaboración)": "EHCAmbientales",
    "E.H Radiaciones no ionizantes (Elaboración)": "EHRadINoIo",
    "E. Ergonómico (Elaboración)": "Eergo",
  };
  isAgente: boolean = false;
  @Input() companyCodigo: string = "";

  @Input() actuactionDetails: any;

  agentes: any[] = [];

  equipos: any[] = [];
  isDetailsAvilable: boolean = false;

  constructor(
    public addActivityModal: NgbActiveModal,
    private datePipe: DatePipe,
    private dropdownService: DropdownService
  ) {}

  ngOnInit(): void {
    this.GetEHReports();
    const actividad = this.actuactionDetails?.ActivtyTypeName ?? "";
    const actuationCode = this.actuationCodeMap[actividad] ?? "";

    const activityDate = this.actuactionDetails?.ActivityDate;
    const formattedDate = activityDate
      ? this.datePipe.transform(activityDate, "yyyyMMdd")
      : "";

    //setting fechaMuestreo from API response
    this.fechaMuestreo = this.actuactionDetails?.ActivityDate
      ? this.datePipe.transform(this.actuactionDetails?.ActivityDate, 'yyyy-MM-dd')
      : '';

    this.referenciaInforme = `${formattedDate}_${actuationCode}_${this.companyCodigo}`;
  }

  agregarAgente(): void {
    this.agentes.push({
      agenteName: "",
      tipologia: "",
      proximoMuestreo: "",
    });
  }

  eliminarAgente(index: number): void {
    this.agentes.splice(index, 1);
  }

  agregarEquipo(): void {
    this.equipos.push({ referenciaCode: "", tipologia: "" });
  }

  eliminarEquipo(index: number): void {
    this.equipos.splice(index, 1);
  }

  guardarInforme(): void {
    const actividad = this.actuactionDetails?.ActivtyTypeName || "";
    const actuationCode = this.actuationCodeMap[actividad] || "";
    const formattedDate = this.datePipe.transform(
      this.actuactionDetails?.ActivityDate,
      "yyyyMMdd"
    );

    const numeroReferenciaInforme = `${formattedDate}_${actuationCode}_${this.companyCodigo}`;

    const dataModel = {
      actuationId: this.actuactionDetails.Id,
      fechaMuestreo: this.fechaMuestreo || "",
      numeroPedido: this.numeroPedido || "",
      proximoInforme: this.proximoInforme || "",
      numeroReferenciaInforme: numeroReferenciaInforme,
      actuationCode: actuationCode,
      centroTrabajoCode: this.companyCodigo,
      createdAt: new Date(),
      agentes: this.agentes,
      equipos: this.equipos,
    };

    this.dropdownService
      .createOrUpdateEHReports(dataModel)
      .subscribe((response) => {
        console.log("Informe guardado correctamente", response);
        this.addActivityModal.close();
      });
  }

  GetEHReports() {
    this.dropdownService
      .getEHReportsByActivityId(this.actuactionDetails.Id)
      .subscribe((response) => {
        this.isDetailsAvilable = response.length > 0;
        this.fechaMuestreo = response[0].fechaMuestreo;
        this.numeroPedido = response[0].numeroPedido;
        this.proximoInforme = response[0].proximoInforme;
        this.referenciaInforme = response[0].numeroReferenciaInforme;
        this.agentes = response[0].agentes || [];
        this.equipos = response[0].equipos || [];
        this.companyCodigo = response[0].centroTrabajoCode;
      });
  }
}
